import Layer from '../../../../Shared/Layer'
import { Trans, withTranslation } from 'react-i18next'
import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import Icon from '../../../../Shared/Icon'
import dayjs from 'dayjs'
import EditImageInformation from '../editImageInformation'
import ImageRoomAssigner from '../../Rooms/ImageRoomAssigner'
import { isRoomImage } from '../utils'

class LayerEditImage extends PureComponent {

  render () {
    return (
      this.props.show ?
        <Layer
          type="side" id={'edit_image_' + this.props.number}
          show={true} onHideClick={this.props.onHideClick}>
          <div className="Imagebrowseritem-Edit">
            <h2><Trans>HEADLINE_EDIT_IMAGE</Trans></h2>
            <div className="Imagebrowseritem-Edit-Image">
              <Icon onClick={() => this.props.onZoomClick(this.props.number)} size="large" type="im"
                    imClassName="im-magnifier"/>
              <img alt={this.props.image.filename} src={this.props.image.thumbnailUrl}/>
            </div>
            <Trans>LABEL_FILENAME</Trans>: {this.props.image.filename}<br/>
            <Trans>LABEL_FILESIZE</Trans>: {LayerEditImage.formatBytes(this.props.image.size, 2)}<br/>
            <Trans>LABEL_DIMENSIONS</Trans>: {this.props.image.width} x {this.props.image.height} px<br/>
            <Trans>LABEL_UPLOADED</Trans>: {this.props.image.createdAt ? dayjs(this.props.image.createdAt).locale(this.props.i18n.language).format('L LT') : '-'}<br/>
            {
              isRoomImage(this.props.image) &&
              <React.Fragment>
                <hr/>
                <ImageRoomAssigner image={this.props.image} rooms={this.props.rooms}
                                   roomAttributes={this.props.roomAttributes}
                                   onImageChanged={this.props.onImageChanged}/>
              </React.Fragment>
            }
            <React.Fragment>
              <hr/>
              <EditImageInformation
                onSave={this.props.onHideClick}
                image={this.props.image}
                onImageChanged={this.props.onImageChanged}
              />
            </React.Fragment>
          </div>
        </Layer>
        : null
    )
  }

  static formatBytes (bytes, decimals) {
    if (bytes === 0) {
      return '0 Bytes'
    }
    let k = 1000,
      dm = decimals || 2,
      sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
      i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
  }
}

LayerEditImage.propTypes = {
  image: PropTypes.object.isRequired,
  rooms: PropTypes.array.isRequired,
  roomAttributes: PropTypes.object.isRequired,
  number: PropTypes.number.isRequired,
  permissions: PropTypes.object.isRequired,
  onImageChanged: PropTypes.func.isRequired,
  onZoomClick: PropTypes.func.isRequired,
  onHideClick: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired
}
export default withTranslation()(LayerEditImage)
